import { useState } from 'react';

import { FileUploadStatus } from '../types';
import { parseCsvIds } from '../utils';

export function useCsvUpload() {
  const [file, setFile] = useState<File | null>(null);
  const [rowsCount, setRowsCount] = useState(0);
  const [status, setStatus] = useState<FileUploadStatus>('');
  const [ids, setIds] = useState<string[]>([]);

  const handleFileUpload = async (file: File | null) => {
    if (!file) return;

    setFile(file);
    setStatus('');

    try {
      const rows = await parseCsvIds(file);
      setRowsCount(rows.length);
      setIds(rows);
      setStatus('loaded');
    } catch (e) {
      setStatus('error');
    }
  };

  return {
    file,
    rowsCount,
    status,
    ids,
    handleFileUpload,
  };
}
